import React from 'react';

export const LexipolLogo = () => (
  <svg
    width='21'
    height='24'
    viewBox='-.076 -.086 21.249 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='#fff'>
      <path d='M10.538-.086v1.85l10.635.998V.912zM15.55 18.449V3.635l-1.754-.163v18.394l1.755-1.11V18.45M10.554 15.724v8.19l1.754-1.108V3.333l-1.754-.162zM18.809 5.818l2.364-1.661-4.119-.383v16.033l1.755-1.108V5.818' opacity='.6' />
      <path d='M7.278 18.449V3.474l-1.755.162v17.099l1.755 1.11v-3.396M10.55 3.17l-1.756.163v19.473l1.755 1.108V3.171M4.02 18.803V3.775l-4.096.38 2.342 1.664v12.858l1.754 1.109v-.983M10.554-.086-.076.911v1.85l10.63-.997z' />
    </g>
  </svg>
);

export const LexipolLogoWithType = () => (
  <svg
    width='119'
    height='24'
    viewBox='0 0 119 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='#fff' clipPath='url(#clip0_logo_with_shield)'>
      <g clipPath='url(#clip1_logo_with_shield)'>
        <path d='M10.538-.086v1.85l10.635.998V.912zM15.55 18.449V3.635l-1.754-.163v18.394l1.755-1.11V18.45M10.554 15.724v8.19l1.754-1.108V3.333l-1.754-.162zM18.809 5.818l2.364-1.661-4.119-.383v16.033l1.755-1.108V5.818' opacity='.6' />
        <path d='M7.278 18.449V3.474l-1.755.162v17.099l1.755 1.11v-3.396M10.55 3.17l-1.756.163v19.473l1.755 1.108V3.171M4.02 18.803V3.775l-4.096.38 2.342 1.664v12.858l1.754 1.109v-.983M10.554-.086-.076.911v1.85l10.63-.997z' />
      </g>
      <path d='M28.774 15.821h7.77v2.943H25.112V.999h3.662zM49.083 11.063h-7.028v4.758h8.248v2.943H38.394V.999h11.884v2.967h-8.223V8.2h7.028v2.869zM59.24 7.12 62.57.995h4.208l-5.172 8.809 5.31 8.956H62.66l-3.415-6.22-3.415 6.22h-4.257l5.31-8.956L51.71.994h4.207l3.332 6.127zM72.419 18.76h-3.662V.998h3.662v17.765zM78.52 12.505v6.259h-3.66V.999h6.928c1.048 0 1.988.148 2.81.438q1.24.443 2.097 1.225a5.3 5.3 0 0 1 1.313 1.865q.451 1.078.453 2.348c0 .846-.152 1.638-.453 2.332q-.45 1.036-1.313 1.767c-.576.487-1.275.866-2.097 1.127-.822.26-1.762.398-2.81.398h-3.267zm0-2.968h3.268q.782.001 1.349-.197a2.4 2.4 0 0 0 .925-.541c.236-.231.418-.512.531-.837a3.2 3.2 0 0 0 .172-1.063q-.001-.573-.172-1.102a2.6 2.6 0 0 0-.531-.94 2.6 2.6 0 0 0-.925-.654q-.568-.245-1.349-.246h-3.267v5.58M105.203 10.28q0 2.039-.547 3.656-.547 1.619-1.545 2.741a6.7 6.7 0 0 1-2.387 1.728c-.925.403-1.948.605-3.06.605s-2.136-.202-3.061-.605a6.9 6.9 0 0 1-2.397-1.728c-.67-.747-1.196-1.663-1.57-2.74s-.56-2.294-.56-3.657v-.782q0-2.023.555-3.647c.37-1.082.891-2.003 1.555-2.756a6.64 6.64 0 0 1 2.392-1.737c.925-.403 1.949-.605 3.06-.605 1.113 0 2.137.202 3.062.605a6.8 6.8 0 0 1 2.391 1.737c.665.758 1.186 1.674 1.555 2.756q.556 1.624.557 3.647zm-3.706-.802q-.002-2.791-.999-4.247c-.664-.97-1.619-1.452-2.854-1.452s-2.19.483-2.854 1.452c-.665.97-1 2.382-1 4.247v.807c0 .925.09 1.747.261 2.46q.261 1.07.758 1.792c.33.482.734.851 1.216 1.097a3.6 3.6 0 0 0 1.648.374q1.855.001 2.845-1.466.989-1.469.989-4.257v-.807zM111.182 15.821h7.77v2.943h-11.431V.999h3.661z' />
    </g>
    <defs>
      <clipPath id='clip0_logo_with_shield'>
        <rect width='118.952' height='24' fill='white' />
      </clipPath>
      <clipPath id='clip1_logo_with_shield'>
        <rect width='21.249' height='24' fill='white' transform='translate(-.076 -.086)' />
      </clipPath>
    </defs>
  </svg>
);
